(function($) {

	var image = $('.random-image'),
	caption = $('.form-caption');
	if (image.length) {
		var ids = JSON.parse(image[0].dataset.imageids),
		vidId = ids,
		rand = Math.floor(Math.random() * vidId.length);
		vidId = vidId[rand];
		image.css('background-image', 'url("' + vidId.image + '")');
		if(caption.length) {
 			caption.text(vidId.image_caption);
		}

		if(image.hasClass('video-popup')) {
			image.attr('href', "//www.youtube.com/watch?v=" + vidId.video_id)
		}
	}

})(jQuery);
